




import { Vue, Prop, Component } from 'vue-property-decorator'
import { PdQualityPropertyNames } from '@/types/pd'

@Component
export default class PdTabModalImage extends Vue {
  @Prop({ type: Number, required: true }) readonly patientId!: number
  @Prop({ type: Number, required: true }) readonly pdId!: number
  @Prop({ type: String, required: true }) readonly type!: PdQualityPropertyNames

  pending = false
  image: string | null = null
  elementInitialized = false

  fetchImage(pdId: number, patientId: number, type: PdQualityPropertyNames) {
    switch (type) {
      case 'wasteFluid':
        return this.$api.pd.fetchWasteFluidImage({
          pdId,
          patientId
        })

      case 'exitsite':
        return this.$api.pd.fetchExitsiteImage({
          pdId,
          patientId
        })
    }
  }

  async showImage(
    patientId: number,
    pdId: number,
    type: PdQualityPropertyNames
  ) {
    this.image = null
    this.pending = true

    try {
      const image = await this.fetchImage(pdId, patientId, type)
      this.image = URL.createObjectURL(image)
    } catch (error) {
      console.error(error)
    } finally {
      this.pending = false
    }
  }

  async created() {
    await this.showImage(this.patientId, this.pdId, this.type)
  }

  destroy() {
    if (this.image) {
      URL.revokeObjectURL(this.image)
    }
  }
}
